import { render, staticRenderFns } from "./SkinItem.vue?vue&type=template&id=a9a62cd4&scoped=true&"
import script from "./SkinItem.vue?vue&type=script&lang=js&"
export * from "./SkinItem.vue?vue&type=script&lang=js&"
import style0 from "./SkinItem.vue?vue&type=style&index=0&id=a9a62cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a62cd4",
  null
  
)

component.options.__file = "SkinItem.vue"
export default component.exports